<!-- Possible made easier by using forms: https://claude.ai/chat/e9dcf31c-cf93-4f35-9b8d-dc3a1140df58 -->
<template>
    <!-- Loading state -->
    <v-container v-if="loading">
        <v-row>
            <v-col cols="12">
                {{ $t('psychologistClients.loading') }}
            </v-col>
        </v-row>
    </v-container>

    <!-- Error state -->
    <v-container v-else-if="error">
        <v-row>
            <v-col cols="12">

            </v-col>
        </v-row>
    </v-container>

    <!-- Loading state -->
    <v-container v-else-if="clients">
        <v-row>
            <v-col class="ml-4" cols="12">
                <div class="ma-4">
                    <span class="font-weight-bold">{{ $t('psychologistClients.clients') }}</span>
                    <v-btn size="x-small" class="ml-2" icon="mdi-account-plus-outline"
                        @click="openClientForm('new')"
                        color="success"
                    />
                </div>


                <!-- Add Client Dialog -->
                <v-dialog v-model="dialog" max-width="600">
                    <!-- <template v-slot:activator="{ props: activatorProps }">
                        <v-btn class="text-none font-weight-regular" prepend-icon="mdi-account" text="Trigger dialog"
                            variant="tonal" v-bind="activatorProps"></v-btn>
                    </template> -->

                    <v-card prepend-icon="mdi-account-plus-outline" :title="$t('psychologistClients.add_client')">
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        :label="$t('psychologistClients.first_name')"
                                        v-model="currentClient.firstName"
                                        :error-messages="formErrors.firstName.message"
                                        :error="formErrors.firstName.value"
                                        required
                                    />

                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field
                                        :label="$t('psychologistClients.last_name')"                                        
                                        v-model="currentClient.lastName"
                                        :error-messages="formErrors.lastName.message"
                                        :error="formErrors.lastName.value"
                                        persistent-hint
                                        required/>
                                </v-col>

                                <v-col cols="12" md="6" sm="6">
                                    <v-text-field
                                        :label="$t('psychologistClients.email')"
                                        v-model="currentClient.email"
                                        required/>
                                </v-col>

                                <v-col cols="12" md="6" sm="6">
                                    <v-text-field
                                        :label="$t('psychologistClients.phone')"
                                        v-model="currentClient.phone"
                                        required/>
                                </v-col>

                                <v-col cols="12" md="6" sm="6">
                                    <v-select
                                        :label="$t('psychologistClients.language')"
                                        v-model="currentClient.language"
                                        :items="[
                                            { title: $t('languages.english'), value: 'en' },
                                            { title: $t('languages.romanian'), value: 'ro' }
                                        ]"
                                    />
                                </v-col>


                                <!-- <v-col cols="12" sm="6">
                                    <v-select :items="['0-17', '18-29', '30-54', '54+']" label="Age*"
                                        required></v-select>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-autocomplete
                                        :items="['Skiing', 'Ice hockey', 'Soccer', 'Basketball', 'Hockey', 'Reading', 'Writing', 'Coding', 'Basejump']"
                                        label="Interests" auto-select-first multiple></v-autocomplete>
                                </v-col> -->
                            </v-row>

                            <small class="text-caption text-medium-emphasis">{{ $t('psychologistClients.indicates_required_field') }}</small>
                        </v-card-text>

                        <v-divider></v-divider>

                        <v-card-actions>
                            <v-spacer></v-spacer>

                            <v-btn :text="$t('psychologistClients.close')" variant="plain" @click="dialog = false"></v-btn>

                            <v-btn color="primary" :text="$t('psychologistClients.save')" variant="tonal" @click="onSave()"></v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog :model-value="deleteDialogVisible" max-width="600">
                    <v-card :title="$t('psychologistClients.delete_client')">
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <div>{{ $t('psychologistClients.you_are_about_to_delete_client') }} {{ currentClient.firstName }} {{ currentClient.lastName }}.</div>
                                        <div>{{ $t('psychologistClients.are_you_sure_you_want_to_proceed') }}</div>
                                        <div>{{ $t('psychologistClients.all_evaluations_will_be_erased') }}</div>
                                    </v-col>
                                </v-row>
                                <v-row >
                                    <v-col cols="12" class="d-flex justify-center">
                                        <v-btn :text="$t('psychologistClients.cancel')" variant="plain" @click="deleteDialogVisible = false"></v-btn>
                                        <v-btn color="error" :text="$t('psychologistClients.delete')" variant="tonal" @click="onDelete()"></v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- //End Add Client Dialog -->
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card v-for="client in sortedClients" :key="`${client.user_id}-card`">
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="3" class="text-center">
                                    <div class="text-caption text-grey">{{ $t('psychologistClients.first_name').replace('*', '') }}</div>
                                    <div>
                                        <router-link :to="`/psychologist/viewClient/${client.user_id}`" class="text-decoration-none text-primary">
                                            {{ client.firstName }}
                                        </router-link>
                                    </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                    <div class="text-caption text-grey">{{ $t('psychologistClients.last_name').replace('*', '') }}</div>
                                    <div>{{ client.lastName }} </div>
                                </v-col>
                                <v-col cols="3" class="text-center">
                                    <div class="text-caption text-grey">{{ $t('psychologistClients.email') }}</div>
                                    <div>{{ client.email }} </div>
                                </v-col>
                                <v-col cols="2" class="text-center">
                                    <div>
                                        <v-btn                                             
                                            icon="mdi-account-edit-outline"  
                                            @click="openClientForm('edit', client)"
                                            size="x-small"
                                        />
                                        <v-btn                                             
                                            icon="mdi-delete-outline"  
                                            @click="openDeleteForm(client)"
                                            size="x-small"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>    

    <!-- Wrong state -->
    <v-container v-else>
        <v-row>
            <v-col cols="12">
                {{ $t('psychologistClients.this_is_bad') }}
            </v-col>
        </v-row>
    </v-container>

</template>

<script>
import apiService from '@/services/ApiService'

export default {
    // components: {
    //     QuestionnaireComponent,
    // },

    data() {
        return {
            clients: [],
            loading: true,
            error: null,
            dialog: false,
            currentClient: {},
            formErrors: {
                firstName: {
                    value: false,
                    message: ''
                },
                lastName: {
                    value: false,
                    message: ''
                }
            },
            deleteDialogVisible: false,
            mode: 'add',
        };
    },

    name: 'ClientList',

    async created() {
        console.log(`ClientList > created`)
        console.log('NODE_ENV:', process.env.NODE_ENV);
        console.log('All process.env:', process.env);
        console.log('VUE_APP_API_ENDPOINT:', process.env.VUE_APP_API_ENDPOINT);

        // const apiUrl = 'http://localhost:7070/api'; // Adjust the API endpoint as needed
        // You can perform any asynchronous operations here if needed
        console.log('ClientList mounted');

        await this.loadClients();
    },

    methods: {

        async loadClients() {
            try {
                let clients = await apiService.getClientsForPsychologist()
                console.log('Response:', clients);

                this.clients = clients;
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        },

        async saveClient(){
            try {
                let clients = await apiService.createClient()
                console.log('Response:', clients);

                this.clients = clients;
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        },
        

        isFormValid(){
            let valid = true
            if(!this.currentClient.firstName || this.currentClient.firstName.trim().length == 0){
                this.formErrors.firstName.value = true;
                this.formErrors.firstName.message = this.$t('psychologistClients.mandatory_field');
                valid &&= false;
            }

            if(!this.currentClient.lastName || this.currentClient.lastName.trim().length == 0){
                this.formErrors.lastName.value = true;
                this.formErrors.lastName.message = this.$t('psychologistClients.mandatory_field');
                valid &&= false;
            }

            return valid;
        },

        resetForm(){
            this.currentClient = {}
        },

        resetErrors(){
            this.formErrors = {
                firstName: {
                    value: false,
                    message: ''
                },
                lastName: {
                    value: false,
                    message: ''
                }
            };
        },

        async onSave(){            
            console.log(`ClientList > onSave > First name: ${this.currentClient.firstName}`)
            console.log(`ClientList > onSave > Last name: ${this.currentClient.lastName}`)
            console.log(`ClientList > onSave > Email: ${this.currentClient.email}`)
            console.log(`ClientList > onSave > Phone: ${this.currentClient.phone}`)
            console.log(`ClientList > onSave > Language: ${this.currentClient.language}`)

            //first reset any previous error
            this.resetErrors()


            if(this.isFormValid()){
                try{
                    console.log('ClientList > onSave > current client values:', this.currentClient);
                    if(this.mode == 'new'){
                        let currentClient = await apiService.createClient(this.currentClient)
                        console.log('ClientList > onAddClionSaveentForm > currentClient:', currentClient);
                    } else if(this.mode == 'edit'){
                        let updatedClient = await apiService.updateUser(this.currentClient.user_id, this.currentClient)
                        console.log('ClientList > onSave > updatedClient:', updatedClient);
                    }

                    this.dialog = false
                    this.resetForm();

                    this.loadClients();
                } catch(error){
                    console.error('ClientList > onSave > Error fetching data:', error);
                }
            }            
        },

        async openClientForm(mode, client){            
            this.resetForm()

            console.log(`ClientList > openClientForm > mode = ${mode}`)            
            
            if(mode == 'new'){
                this.mode = mode
            } else if(mode == 'edit'){
                this.mode = mode
                this.currentClient = client
            } else {
                throw new Error("ClientList > openClientForm > Wrong mode")
            }
            this.dialog = true;            
        },

        async openDeleteForm(client){
            console.log(`ClientList > openDeleteForm`)

            this.deleteDialogVisible = true;
            this.currentClient = client;
        },

        async onDelete(){            
            //first reset any previous error
            this.resetErrors()

            try{
                console.log('ClientList > onDelete > current client values:', this.currentClient);

                let deleted = await apiService.deleteUser(this.currentClient.user_id)
                console.log('ClientList > onSave > client deleted:', deleted);

                this.deleteDialogVisible = false                

                this.loadClients();
            } catch(error){
                console.error('ClientList > onSave > Error fetching data:', error);
            }
        },

        // onRow(evaluationId) {
        onRow(clientId) {
            // console.log(`PsychologistEvaluations > onRow > evaluationId = ${evaluationId}`);
            console.log(`ClientList > onRow > clientId = ${clientId}`);
            
            // Navigate with parameters
            this.$router.push({ 
                path: `/psychologist/viewClient/${clientId}`, 
            })
        }
    },

    computed:{
        sortedClients(){
            return this.clients.sort((c1, c2) => c1.firstName > c2.firstName)
        }
    },

    

}
</script>

<style scoped></style>